import { cubicEaseOut, transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { FontFamily } from '@helpers/fontEnum';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { ComponentTheme } from '@helpers/themeEnum';
import { contentStyles, paragraphLarge, paragraphSmall } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div ``;
const Item = styled(m.div) `
  --borderColour: ${brand.grey.grey16};
  border-bottom: 1px solid var(--borderColour);

  &[data-font-family=${FontFamily.Lustria}] {
    &:last-child {
      border-bottom: none;
    }
  }

  &[data-theme=${ComponentTheme.Black}] {
    --borderColour: ${brand.grey.grey16};
  }

  &[data-theme=${ComponentTheme.White}] {
    --borderColour: ${brand.white};
  }

  &[data-theme=${ComponentTheme.Blue}] {
    --borderColour: ${brand.blue.base};
  }

  &[data-theme=${ComponentTheme.Green}] {
    --borderColour: ${brand.green.base};
  }

  &[data-theme=${ComponentTheme.Orange}] {
    --borderColour: ${brand.orange.base};
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --borderColour: ${brand.yellow.base};
  }
`;
const ItemHeader = styled.button `
  ${paragraphLarge};
  ${ButtonReset};

  display: flex;
  align-items: center;
  padding: ${fluid(16, 32)} 0;
  margin: 0;
  text-align: left;
  width: 100%;

  ${Item}[data-font-family=${FontFamily.Lustria}] & {
    padding: ${fluid(18, 36)} 0 ${fluid(14, 30)};

    ${Item}:last-child & {
      padding-bottom: 0;
    }
  }

  ${Item}:first-child & {
    padding-top: 0;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 5px;
    outline-color: ${brand.black};
  }
`;
const ItemTitle = styled.h3 `
  display: block;
  flex: 1 1 auto;
  font-size: ${fluid(18, 22)};
  line-height: ${fluid(28, 28)};
  ${fonts.montserrat.medium};

  ${Item}[data-font-family=${FontFamily.Lustria}] & {
    font-size: ${fluid(24, 40)};
    line-height: ${fluid(34, 50)};
    ${fonts.lustria.regular};
  }
`;
const ItemIcon = styled.span `
  display: flex;
  transition: transform 0.25s ${cubicEaseOut};

  svg {
    width: 12px;
  }

  [aria-expanded='true'] & {
    transform: rotate(-180deg);
  }
`;
const ItemTitleIcon = styled.span ``;
const ItemBody = styled(m.div) `
  min-width: 0;
  overflow: hidden;
`;
const ItemBodyContent = styled.div `
  ${contentStyles};
  padding-bottom: ${fluid(16, 48)};

  p:last-child {
    margin-bottom: 0;
  }

  p,
  ul li {
    ${paragraphSmall};
  }

  ul li {
    margin-bottom: 0;
  }

  a {
    ${transition('text-decoration-color')};

    &:focus,
    &:hover {
      text-decoration-color: ${brand.black};
    }
  }
`;
export default {
    Container,
    Item,
    ItemBody,
    ItemBodyContent,
    ItemHeader,
    ItemIcon,
    ItemTitle,
    ItemTitleIcon,
};
